import React, { useEffect, FC } from "react";
import {
    Modal,
    ModalBody,
    Form,
} from "reactstrap";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
    Col,
    RSelect,
    Block,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    PreviewCard,
    BlockBetween,
    Button,
    Icon
} from "../../../components/Component";
import { Steps, Step } from "react-step-builder";
import { useForm, FormProvider } from "react-hook-form";
import BillingandPaymentTerms from "./BillingandPaymentTerms";
import ComplianceandCertifications from "./ComplianceandCertifications";
import ConflictResolution from "./ConflictResolution";
import ContractorInformation from "./ContractorInformation";
import LegalInformation from "./LegalInformation"
import ContractorProfile from "./ContractorProfile";
import ContactInformation from "./ContactInformation";
import ContractualAgreements from "./ContractualAgreements";
import EmergencyResponseandContingencyPlans from "./EmergencyResponseandContingencyPlans";
import EnvironmentalandSustainabilityConsiderations from "./EnvironmentalandSustainabilityConsiderations";
import QualityAssuranceInspection from "./QualityAssuranceInspection";
import ScopeofWork from "./ScopeofWork";
import Header from "./Header";
import { useNavigate } from 'react-router-dom';

const config = {
    before: Header as React.ComponentType<{}> as () => React.ReactElement,
};

const AddContractors: React.FC = (props: any) => {
    const navigate = useNavigate();
    const formMethods = useForm({
        mode: "onSubmit",
    });
    useEffect(() => {
    }, []);

    const backList = () => {
        navigate(`/general-contractors`);

    }

    return (

        <React.Fragment>
            <Head title="Regular Page v-1" />
            <Content>
                {/* {cookiesEnabled ? (
            <p>Cookies are enabled in your browser.</p>
        ) : (
            <p>Cookies are not enabled in your browser.</p>
        )} */}
                <BlockHead size="lg">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h4">Create Contractors</BlockTitle>
                            <BlockDes>Onboard Contractors platform, collecting essential information to create Contractors profiles.</BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <Button color="primary" className="btn-dim" onClick={() => backList()}>
                                <Icon name="menu-alt-r"></Icon>
                                <span>List of Contractors</span>
                            </Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewCard className={'cardBox'} bodyClass="card-inner-xl">
                        {/* <div className="nk-wizard nk-wizard-simple is-vertical is-alter wizard clearfix"> */}
                            <div className="nk-wizard nk-wizard-simple is-alter wizard clearfix"> 
                            <FormProvider {...formMethods}>
                                <Steps config={config}>
                                    <Step component={ContractorInformation} />
                                    <Step component={ContactInformation} />
                                    {/* <Step component={ContractorProfile} /> */}
                                    {/* <Step component={LegalInformation} /> */}
                                    <Step component={ComplianceandCertifications} />
                                    {/* <Step component={ScopeofWork} /> */}
                                    {/* <Step component={BillingandPaymentTerms} /> */}
                                    {/* <Step component={ContractualAgreements} /> */}
                                    {/* <Step component={QualityAssuranceInspection} /> */}
                                    {/* <Step component={EnvironmentalandSustainabilityConsiderations} /> */}
                                    <Step component={EmergencyResponseandContingencyPlans} />
                                    {/* <Step component={ConflictResolution} /> */}
                                </Steps>
                            </FormProvider>
                        </div>
                    </PreviewCard>
                </Block>
            </Content>
        </React.Fragment>
    );
};
export default AddContractors;
